import type RootStore from "stores/RootStore";
import type { DialogType } from "types/DialogType";
import DevOpsLinkDialogStore, { DEVOPS_LINK_DIALOG_NAME } from "./DevOpsLinkDialogStore";

/**
 * The routed "Link a project" dialog, for any route's `dialogs: [...]` — the
 * DevOps Overview registers it; Project 360 (and Client 360, once it adopts
 * the shared dialog) spread the same object so one definition serves all.
 * Dialogs are per route in this router, which is why this is exported rather
 * than declared inline on one route.
 *
 * A failed save THROWS from `onSubmit` so the dialog stays open with the
 * server's message in the form's alert (the DevOps Subscriptions dialog's
 * convention); a successful one lets the router close it.
 */
export const devopsLinkDialog: DialogType = {
  name: DEVOPS_LINK_DIALOG_NAME,
  title: "Link a project",
  component: () => import("./DevOpsLinkDialog"),
  cancelButton: true,
  submitButtonText: "Link",
  maxWidth: "sm",
  height: 700,
  onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = rootStore.devopsLinkDialogStore as DevOpsLinkDialogStore;
    const ok = await store.save();
    if (!ok) {
      throw new Error(store.formError || "Failed to save the link");
    }
  },
  onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
    const store = rootStore.devopsLinkDialogStore as DevOpsLinkDialogStore | undefined;
    return store?.isValid ?? false;
  },
};
